module.exports = __webpack_public_path__ + "media/images/redesign-images/home-new/home-slides/prod-02-4cd6b67da2663adb00b9b15116dc1382.jpg";